import { useState, useEffect, useCallback, useRef } from "react";
import { formatInputToCapitalization } from "../Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";

export const useInputAction = ({ data, setData, validations, refs, check_dropdown, inputRefs }) => {

    const [submitConfirm, setSubmitConfirm] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        //console.log('handleChangeGodown', name, value);
        if (e.code === "Space") {
            e.preventDefault();
            const cursorPosition = e.target.selectionStart;
            if (cursorPosition === 1) {
                setData({ ...data, [name]: "" });
                return;
            }
        }
        if (e.altKey && e.key === 'Enter') {
            e.preventDefault();
            if (name === 'address') {
                const nextInputRef = refs[name]?.curr?.current;
                if (nextInputRef) {
                    nextInputRef.value = nextInputRef.value + "\r\n";
                }
            }
            return
        }

        // Apply field-specific validations
        const validation = validations[name];
        if (validation) {
            const isValid = validation(value);
            if (isValid || value === "") {
                const updatedValue = (name === 'company_name' || name === 'mailing_name' || name === 'address' || name === 'city' || name === 'name' || name === 'ledger_name' || name === 'alise_name' || name === 'symbol' || name === 'formal_name')
                    ? formatInputToCapitalization(value)
                    : (name === 'no_of_decimal_place' || name === 'no_of_decimal_place_for_amount')
                        ? value.slice(-1)
                        : value;
                setData((prevData) => {
                    const updatedData = { ...prevData, [name]: updatedValue };
                    console.log('updatedData', updatedData);
                    return updatedData;
                })


            }
        } else {
            flushSync(setData({ ...data, [name]: value }))

        }
    };

    const handleDropdownClick = (name, value) => {
        let nextField = null;

        // Default sequential navigation
        const fields = Object.keys(inputRefs);
        const currentIndex = fields.indexOf(name);
        nextField = fields[currentIndex + 1] || null;


        if (nextField && inputRefs[nextField]?.current) {
            inputRefs[nextField].current.focus();
            inputRefs[nextField].current.setSelectionRange(0, inputRefs[nextField].current.value.length);
        } else {
            setSubmitConfirm('Accept')
            inputRefs[name]?.current?.blur();
        }
    }

    const handleFocus = (e) => {
        const { name } = e.target;
        const focusAction = refs[name]?.onFocus;
        if (name === 'alias_name' || name === 'name') {
            setSubmitConfirm("");
        }
        if (focusAction) focusAction();
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        const blurAction = refs[name]?.onBlur;
        if (blurAction) blurAction(value, setData);
    };

    const handleKeyDown = (e) => {
        const { name, value } = e.target;
        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            e.stopPropagation();
            let nextField = null;
            setSubmitConfirm("");
            // Default sequential navigation
            const fields = Object.keys(inputRefs);
            const currentIndex = fields.indexOf(name);
            nextField = fields[currentIndex - 1] || null;


            if (nextField && inputRefs[nextField]?.current) {
                inputRefs[nextField].current.focus();
                inputRefs[nextField].current.setSelectionRange(0, inputRefs[nextField].current.value.length);
            }
            return;
        }
        if (e.key === "Enter") {
            e.preventDefault();
            if (name === 'company_name') {
                setData({ ...data, mailing_name: value })
            }
            handleDropdownClick(name, value);
            return;
        }

    }



    return {
        data,
        setData,
        handleChange,
        handleFocus,
        handleBlur,
        handleKeyDown,
        submitConfirm,
        setSubmitConfirm,
        handleDropdownClick
    };
};
